import * as Yup from 'yup';

import { env } from 'Shared/constants/env';

export const validationSchema = Yup.object().shape({
  frequency: Yup.string().required('Required'),
  dayOfWeek: Yup.string().when('frequency', {
    is: (val: string) => val === 'weekly' || val === 'bi_weekly',
    then: Yup.string().required('Required'),
    otherwise: Yup.string(),
  }),
  biweeklyDate: Yup.string().when('frequency', {
    is: (val: string) =>
      val === 'bi_weekly' && env.paymentFlexibilityEveryTwoWeeks,
    then: Yup.string().required('Required'),
    otherwise: Yup.string(),
  }),
  semiMonthlyDates: Yup.string().when('frequency', {
    is: (val: string) => val === 'semi_monthly',
    then: Yup.string().required('Required'),
    otherwise: Yup.string(),
  }),
  monthly: Yup.string().when('frequency', {
    is: (val: string) => val === 'monthly',
    then: Yup.string().required('Required'),
    otherwise: Yup.string(),
  }),
});
